/* istanbul ignore file */

// Test coverage is in src/pages-tests/PartnerSignUp.spec.tsx
import { PartnerSignUp } from 'src/components/organisms/PartnerSignUp/PartnerSignUp';

export default PartnerSignUp;
